import { Outlet, useLocation } from 'react-router-dom';

import { WidgetErrorBoundary } from '../common/WidgetErrorBoundary';
import { ContextSidebar } from './ContextSidebar';
import { Header } from './Header';

export const AppShell = () => {
  // key по pathname: после ошибки рендера страница пробует отрисоваться
  // заново при переходе на другой маршрут.
  const { pathname } = useLocation();
  return (
    <div className="flex h-screen w-full flex-col overflow-hidden bg-surface-page">
      <Header />
      <div className="flex min-h-0 flex-1">
        <WidgetErrorBoundary>
          <ContextSidebar />
        </WidgetErrorBoundary>
        <main className="relative min-w-0 flex-1 overflow-y-auto">
          <WidgetErrorBoundary key={pathname}>
            <Outlet />
          </WidgetErrorBoundary>
        </main>
      </div>
    </div>
  );
};
